import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createBill, deleteBillById, getAllBills } from "../../api/bill";
// import { useRouter } from "next/router";
// import Link from "next/link";
// import toast from "react-hot-toast";
import { getVendorList } from "../../api/vendor";
import AgTable from "../../component/Ag-Table/AgTable";
import { Link } from "react-router-dom";
import { Add, Clear, Delete, Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
    Collapse,
      CircularProgress,
        Chip,
  Card,
  CardContent,
  Avatar,
  LinearProgress,
  Divider,
  Tooltip,
} from "@mui/material";
import { insertExpensesData, updateExpensebyID } from "../../api/expensesManagement";
import { showAlert, showSuccess } from "../../actions/alert";
import { getPurchases } from "../../api/purchase";
import { getAllInventory } from "../../api/inVentory";
const expenseTypes = ["Labor", "Material", "Equipment"];
const initialExpense = {
 "vendor_id" : "", 
    "po_number" : "", 
    "total_amount" : "", 
    "po_id" : "",
    "payment_terms" : "", 
    "bill_date" : "", 
    "due_date" : "", 
    "memo" : "",  
};
const PaymentTermsList = ["Due On Receipt", "Due On Receipt", "Net 7","Net 10","Net 15","Net 30","Net 40","Net 45","Net 60"];

export default function Bills() {
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
    const [formData, setFormData] = useState(initialExpense);
  const [vendorName, setVendorName] = useState("");
  const [billNumber, setBillNumber] = useState("");
  const [allVendorList, setAllVendorList] = useState([]);
  const user = useSelector((state) => state.user);
  const [filter, setFilter] = useState();
  const [deleteId, setDeleteId] = useState(false);
  // const router = useRouter();
  const [gridApi, setGridApi] = useState(null);
  const [BillNO, setBillNO] = useState("");
  const [Status, setStatus] = useState("");
  const [Pono, setPono] = useState("");
  const [rowData, setRowData] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
const dispatch= useDispatch();
    const [expenses, setExpenses] = useState([]);
    const [sitesData, setSitesData] = useState([]);
    const [projectId, setProjectId] = useState("");
    const [projects, setProjects] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [employeesList, setEmployeesList] = useState([]);
    const [taskDisabled, setTaskDisabled] = useState(true);
    const [invetoryArray, setInventoryArray] = useState([]);
      const [expandedRows, setExpandedRows] = useState({});
    
      const [subTableData, setSubTableData] = useState({});
      const [loadingRows, setLoadingRows] = useState({});
    const [lineItems, setLineItems] = useState([
      { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
    ]);

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const billTable = [
    {
      headerName: "Bill Number",
      field: "bill_number",
      resizable: true,
      // cellRenderer: (params) => (
      //   <>
      //     <div className="flex gap-3">
      //       <Link
      //         href={`/bills/${params?.data?.id}`}
      //         className="cursor-pointer py-1 text-[#fff] to-[#145df1] capitalize h-[40px] p-[5px] text-sm font-normal rounded-[5px] w-[40px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
      //       >
      //         <span className="text-blue-800 font-semibold cursor-pointer underline  px-[10px] py-[5px]">
      //           {params?.value}
      //         </span>
      //       </Link>
      //     </div>
      //   </>
      // ),
      wrapText: true,
      minWidth: 150,
      maxWidth: 300,
    },
    {
      headerName: "PO Number",
      field: "po_number",
      resizable: true,
      wrapText: true,
      // cellRenderer: (params) => (
      //   <>
      //     <div className="flex gap-3">
      //       <Link
      //         href={`/purchase-orders/${params?.data?.po_id}`}
      //         className="cursor-pointer py-1 text-[#fff] to-[#80aaff] capitalize h-[40px] p-[5px] text-sm font-normal rounded-[5px] w-[40px] flex items-center justify-center hover:bg-[#80aaff] hover:text-[#fff]"
      //       >
      //         <span className="text-[#6093fa] font-semibold cursor-pointer underline  px-[10px] py-[5px]">
      //           {params?.value}
      //         </span>
      //       </Link>
      //     </div>
      //   </>
      // ),
      minWidth: 150,
      maxWidth: 300,
    },
    // {
    //   headerName: "PO ID",
    //   field: "po_id",
    //   resizable: true,
    //   wrapText: true,
    //   minWidth: 150,
    //   maxWidth: 300,
    // },
    {
      headerName: "Vendor",
      field: "vendor_name",
      resizable: true,
      wrapText: true,
      cellEditor: "textAreaEditor",
      cellRenderer: (params) => (
        <>
          {" "}
          <div
            style={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {params?.data?.vendor_name}
          </div>
        </>
      ),
      minWidth: 180,
      maxWidth: 250,
    },
    {
      headerName: "Payment Terms",
      field: "payment_terms",
      resizable: true,
      wrapText: true,
      minWidth: 200,
      maxWidth: 350,
    },
    {
      headerName: "Bill Date",
      field: "bill_date",
      resizable: true,
      wrapText: true,
      cellRenderer: (params) => <>{convertDateIsoDate(params)}</>,
      minWidth: 200,
      maxWidth: 350,
    },
    {
      headerName: "Due Date",
      field: "due_date",
      resizable: true,
      wrapText: true,
      cellRenderer: (params) => <>{convertDateIsoDate(params)}</>,
      minWidth: 200,
      maxWidth: 350,
    },

    {
      headerName: "Status",
      field: "status",
      resizable: true,
      wrapText: true,
      cellRenderer: (params) => (
        <span
          className={`${
            params?.data?.status === "Paid"
              ? "text-green-600"
              : params?.data?.status === "Pending"
              ? "text-yellow-600"
              : "text-red-600"
          } font-semibold`}
        >
          {params?.data?.status}
        </span>
      ),
      minWidth: 150,
      maxWidth: 300,
    },
    {
      headerName: "Due Amount",
      field: "due_amount",
      resizable: true,
      wrapText: true,
      cellRenderer: (params) => (
        <>
          {params?.data?.due_amount === null
            ? 0
            : parseFloat(params?.data?.due_amount).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
        </>
      ),
      minWidth: 150,
      maxWidth: 300,
    },
    {
      headerName: "Total Amount",
      field: "total_amount",
      resizable: true,
      wrapText: true,
      cellRenderer: (params) => (
        <>
          {(parseFloat(params?.data?.total_amount) || 0).toLocaleString(
            "en-US",
            { style: "currency", currency: "USD" }
          )}
        </>
      ),
      minWidth: 150,
      maxWidth: 300,
    },
    {
      headerName: "Memo",
      field: "memo",
      resizable: true,
      wrapText: true,
      minWidth: 250,
      maxWidth: 400,
    },
    {
      headerName: "Created At",
      field: "created_at",
      resizable: true,
      wrapText: true,
      cellRenderer: (params) => <>{convertDateIsoDate(params)}</>,
      minWidth: 200,
      maxWidth: 350,
    },
    // {
    //   headerName: "Created By",
    //   field: "created_by",
    //   resizable: true,
    //   wrapText: true,
    //   minWidth: 200,
    //   maxWidth: 350,
    // },
  ];

    const handleClose = () => {
    setFormData(initialExpense);
    setLineItems([
      { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
    ]);
    setOpen(false);
  };

    const handleSave = async (event) => {
      event.preventDefault();
  
      if (editMode) {
        try {
          const { data } = await updateExpensebyID(
            { ...formData, orderline: lineItems },
            user.token,
            formData.id
          );
          if (data.status) {
            // setSites(
            //   sites.map((site) => (site.id === formData.id ? formData : site))
            // )
            dispatch(showAlert("bill Created Successfully"));
            refreshTable();
            // fetchExpensesData();
            // showSuccess("Expense Created Successfully");
          }
        } catch (error) {
          console.error("Error updating site:", error);
        } finally {
          setLineItems([
            { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
          ]);
          setFormData(initialExpense);
        }
      } else {
        try {
          const { data } = await createBill(
            { ...formData, orderline: lineItems },
            user.token
          );
          if (data.status) {
            // setSites(
            //   sites.map((site) => (site.id === formData.id ? formData : site))
            // )
            // fetchExpensesData();
            dispatch(showAlert("bill Created Successfully"));
            refreshTable();
  
            showSuccess("bill Created Successfully");
          }
        } catch (error) {
          console.error("Error updating site:", error);
        } finally {
          setLineItems([
            { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
          ]);
          setFormData(initialExpense);
        }
      }
  
      setOpen(false);
    };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updated = { ...formData, [name]: value };

    // if (["hoursOrQty", "rate"].includes(name)) {
    //   const qty = name === "hoursOrQty" ? +value : +formData.hoursOrQty;
    //   const rate = name === "rate" ? +value : +formData.rate;
    //   updated.Amount = qty * rate;
    // }

    setFormData(updated);
  };
  
        const handleLineItemChange = (index, field, value) => {
        const updatedItems = [...lineItems];
        updatedItems[index][field] = value;
        if (field === "inventory_id") {
          const selectedInventory = invetoryArray.find(
            (item) => item.id.toString() === value.toString()
          );
          if (selectedInventory) {
            updatedItems[index].unit_price = selectedInventory.unit_price || "";
          } else {
            updatedItems[index].unit_price = "";
          }
        }
        // Recalculate total amount
        const totalAmount = updatedItems.reduce((sum, item) => {
          const price = parseFloat(item.unit_price) || 0;
          const qty = parseFloat(item.quantity) || 0;
          return sum + price * qty;
        }, 0);
    
        setLineItems(updatedItems);
        setFormData((prev) => ({
          ...prev,
          total_amount: totalAmount.toFixed(2),
        }));
      };

  const addLineItem = () => {
    setLineItems([
      ...lineItems,
      { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
    ]);
  };

  const removeLineItem = (index) => {
    const updatedItems = [...lineItems];
    updatedItems.splice(index, 1);

    const totalAmount = updatedItems.reduce((sum, item) => {
      const price = parseFloat(item.unit_price) || 0;
      const qty = parseFloat(item.quantity) || 0;
      return sum + price * qty;
    }, 0);

    setLineItems(updatedItems);
    setFormData((prev) => ({
      ...prev,
      total_amount: totalAmount.toFixed(2),
    }));
  };

  // const handleOpen = () => {
  //   setFormData(initialExpense);
  //   setEditMode(false);
  //   setOpen(true);
  // };

 useEffect(() => {
    if (rowData.length > 0) {
      filterDataByDateRange();
    }
  }, [rowData, fromDate, toDate]);

  const filterDataByDateRange = () => {
    let filtered = [...rowData];

    if (fromDate || toDate) {
      filtered = rowData.filter((item) => {
       
        const itemDate = item.bill_date || item.created_date || item.po_date;

        if (!itemDate) return true; 

        const itemDateObj = new Date(itemDate);
        const fromDateObj = fromDate ? new Date(fromDate) : null;
        const toDateObj = toDate ? new Date(toDate) : null;

        // Set time to start/end of day for proper comparison
        if (fromDateObj) fromDateObj.setHours(0, 0, 0, 0);
        if (toDateObj) toDateObj.setHours(23, 59, 59, 999);

        if (fromDateObj && toDateObj) {
          return itemDateObj >= fromDateObj && itemDateObj <= toDateObj;
        } else if (fromDateObj) {
          return itemDateObj >= fromDateObj;
        } else if (toDateObj) {
          return itemDateObj <= toDateObj;
        }

        return true;
      });
    }

    setFilteredRowData(filtered);
  };
  const fetchAllBillLists = async (limit, offset) => {
    try {
      const { data } = await getAllBills(user.token, {
        limit: limit,
        offset: offset,
        po_number: Pono,
        status: Status,
        bill_number: BillNO,
        from_date: fromDate,
        to_date: toDate,
      });

      if (data.status) {
        setDeleteId(false);
        return {
          rows: data.data.BillItems,
          total: parseInt(data.data.totalBill),
          error: false,
        };
      }
    } catch (error) {
      setDeleteId(false);
      return { error: true };
    }
  };

  const onDelete = async (id) => {
    setDeleteId(true);
    try {
      const res = await deleteBillById(id, user.token);
      setDeleteId(false);
      // toast.success(res.data.msg);
      refreshTable();
    } catch (error) {
      setDeleteId(false);
      // toast.error(error.message);
    }
  };

  useEffect(() => {
    getAllVendorsData();
     purchaseOrderList();
     fetchAllInvetory();
  }, [user.token]);

  const getAllVendorsData = async () => {
    try {
      const { data } = await getVendorList(user.token, {});
      setAllVendorList(data.data);
    } catch (error) {
      // toast.error(error.message);
    }
  };

  const purchaseOrderList = () => {
    getPurchases({},user.token)
      .then((res) => {
        setProjects(res.data.data);
      })
      .catch((err) => console.error("Error fetching projects:", err));
  };
  useEffect(() => {
    refreshTable();
  }, [BillNO, Status, Pono,fromDate && toDate]);
  const reset = () => {
    setBillNO("");
    setStatus("");
    setPono("");
    setFromDate("");
    setToDate("");
  };

  // const onSubmit = async (event) => {
  //   // event.preventDefault();
  //   try {
  //     const res = await ThreeWayMatchData(user.token, event);
  //     if (res.data.status) {
  //       setModalIsOpen(true);
  //       setRowData(res.data.data);
  //       setBillNumber(event);
  //       // setResponseData(res.data.data.Result.matchedItems);
  //       // setUnmatchedPOItems(res.data.data.Result.unmatchedPOItems);
  //       // setUnmatchedBillItems(res.data.data.Result.unmatchedBillItems);
  //       // setPo("false")
  //     }
  //   } catch (error) {
  //     setModalIsOpen(false);
  //     // toast.error(error.message);
  //   }
  // };
  const handleOpen = () => {
    setFormData(initialExpense);
    setEditMode(false);
    setOpen(true);
  };
      const fetchAllInvetory = async () => {
          try {
            const { data } = await getAllInventory(user.token, {
              limit: "",
              offset: "",
              status: "stock_item",
              vendorname: "",
              manufacturer: "",
              category: "",
              internalSku: "",
              itemDescription: "",
              is_active: "t",
            });
            // setRefresh(false);
            // setMovethenRefresh(false);
            setInventoryArray([...data.data.Inventory]);
            return {
              rows: data.data.Inventory,
              total: parseInt(data.data.total),
              error: false,
            };
          } catch (error) {
            console.log(error?.message);
            // setMovethenRefresh(false);
            // setRefresh(false);
            return { error: true };
          }
        };
  return (
    <>
    
           <Box className="pmt-title-box">
                <Box className="typography-title w-full flex justify-between">
                  <Typography variant="h1" className="pmt-headings-h1 ">
                   Bills
                  </Typography>
                    <Button
                            variant="contained"
                            className="blue-button"
                            startIcon={<Add />}
                            onClick={handleOpen}
                            type="button"
                          >
                            Add Bills
                          </Button>
                </Box>
              
    

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-2 bg-[#fff] rounded-[10px] p-3 mb-2">
          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by Bill No.
            </label>
            <input
              type="text"
              value={BillNO || ""}
              onChange={(e) => setBillNO(e.target.value)}
              placeholder="Enter the Invoice Payment No."
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="col-span-1 sm:col-span-1 lg:col-span-1 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by Status
            </label>
            <input
              type="text"
              value={Status || ""}
              onChange={(e) => setStatus(e.target.value)}
              placeholder="Enter the Status"
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by PO Number
            </label>
            <input
              type="text"
              value={Pono || ""}
              onChange={(e) => setPono(e.target.value)}
              placeholder="Enter the PO Number"
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by Start Date
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by End Date
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              min={fromDate}
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="col-span-1 sm:col-span-1 lg:col-span-1  flex justify-start items-end">
            {BillNO || Status || Pono||fromDate||toDate ? (
              <button
                onClick={() => reset()}
                className="bg-[#000000] items-center flex gap-1 mb-1 text-[#fff] rounded-[5px] px-[10px] py-[5px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-[15px] h-[15px]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
                RESET
              </button>
            ) : null}
          </div>
          {/* <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1  flex-justify-center items-center">
            <label className="capitalize text-[#000] mb-2 font-medium"></label>
            <button
              type="button"
              onClick={() => router.push(`/bills/create-bill`)}
              className="bg-[#00308F] gap-2 h-[45px] text-[#fff] font-semibold capitalize p-[5px] text-md text-sm rounded-[5px] px-[20px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff] float-right"
            >
              Create Bill
            </button>
          </div> */}
        {/* </div> */} 
        </Box>
         <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 sm:gap-4 rounded-[10px] p-4 sm:p-6 mb-2 bg-[#fff] my-[10px]"
      >
        {/* Bill No */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="bill-no-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by Bill No.
          </label>
          <input
            id="bill-no-input"
            type="text"
            value={BillNO || ""}
            onChange={(e) => setBillNO(e.target.value)}
            placeholder="Enter the Bill No."
            className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* Status */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="status-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by Status
          </label>
          <input
            id="status-input"
            type="text"
            value={Status || ""}
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Enter the Status"
            className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* PO Number */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="po-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by PO Number
          </label>
          <input
            id="po-input"
            type="text"
            value={Pono || ""}
            onChange={(e) => setPono(e.target.value)}
            placeholder="Enter the PO Number"
            className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* Start Date */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="from-date-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by Start Date
          </label>
          <input
            id="from-date-input"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full h-10 sm:h-11 rounded-md text-[#000] border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* End Date */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="to-date-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by End Date
          </label>
          <input
            id="to-date-input"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            min={fromDate}
            className="w-full h-10 sm:h-11 text-[#000] rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* Reset Button */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 flex justify-start items-end">
          {BillNO || Status || Pono || fromDate || toDate ? (
            <button
              onClick={() => reset()}
              className="group inline-flex items-center gap-1 mb-1 rounded-[5px] px-[12px] py-[6px] text-xs sm:text-sm font-medium text-white bg-gray-900 hover:bg-gray-800 active:scale-95 transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-gray-900"
            >
              {/* Icon (refresh) */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-[15px] h-[15px] group-hover:rotate-[-20deg] transition-transform duration-150"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
              RESET
            </button>
          ) : null}
        </div>
        </div>
        {/* Filter and Table Section */}
        <div className="bg-white rounded-lg shadow-lg mt-[20px]">
          {/* Filters */}

          {/* Table */}
          <div className="col-span-2 mt-1 mb-4 ag-theme-material owb-table">
            <AgTable
              getTableRows={fetchAllBillLists}
              columns={[
                {
                  headerName: "Actions",
                  field: "actions",
                  minWidth: 120,
                  cellRenderer: (params) => (
                    <>
                      <div className="flex w-full gap-3 justify-center">
                        <button
                          disabled={deleteId}
                          onClick={() => onDelete(params?.data?.id)}
                          // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
                          title="delete"
                        >
                          <img
                            width="28"
                            height="28"
                            src="https://img.icons8.com/fluency-systems-filled/48/808080//trash.png"
                            alt="filled-trash"
                          />
                        </button>
                        {/* <button
                          // disabled={deleteId}
                          onClick={() => onSubmit(params?.data?.id)}
                          // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
                          title="3 Way Match"
                        >
                          <img
                            width="28"
                            height="28"
                            src="https://img.icons8.com/color/48/search--v1.png"
                            alt="Match"
                          />
                        </button> */}
                      </div>
                    </>
                  ),
                },
                ...billTable,
              ]}
              perPage={10}
              refresh={tableRefreshCount}
              setRefresh={""}
              classN={""}
              setGridData={""}
              gridOptions={""}
              setGridApi={setGridApi}
              gridApi={gridApi}
              components={""}
            />
          </div>
        </div>
          <Dialog  className="flex justify-center expense-modal" open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>{editMode ? "Edit Bill" : "Add Bill"}</DialogTitle>
        <form onSubmit={handleSave} >
          <DialogContent className="!h-[470px] overflow-scroll">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Purchase Order</InputLabel>
                  <Select
                    name="po_id"
                    value={formData.po_id}
                     onChange={(e) => {
    const selectedPoId = e.target.value;
    const selectedPo = projects.find((p) => p.id === selectedPoId);

    handleChange(e); // assuming this updates po_id

    setFormData((prev) => ({
      ...prev,
      po_number: selectedPo?.po_number || '',
    }));
  }}
                    required
                  >
                    <MenuItem value="">
                      <em>Select Purchase Order</em>
                    </MenuItem>
                    {projects.map((p, i) => (
                      <MenuItem key={i} value={p.id}>
                        {p.po_number}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel>Vendor</InputLabel>
                  <Select
                    name="vendor_id"
                    value={formData.vendor_id}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value="">
                      <em>Select Vendor</em>
                    </MenuItem>
                    {allVendorList?.map((site) => (
                      <MenuItem key={site.id} value={site.id}>
                        {site.vendor_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                  <InputLabel>Payment Terms</InputLabel>
                    <Select
                    name="payment_terms"
                    value={formData.payment_terms}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value="">
                      <em>Select Payment Terms</em>
                    </MenuItem>
                    {PaymentTermsList?.map((terms) => (
                      <MenuItem key={terms} value={terms}>
                        {terms}
                      </MenuItem>
                    ))}
                  </Select>
                  </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  name="bill_date"
                  label="Bill Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.bill_date}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  name="due_date"
                  label="Due Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.due_date}
                  onChange={handleChange}
                />
              </Grid>
                   
                   <Grid item xs={12} sm={4}>
                                       <h2 className="text-[#000] font-semibold flex items-center justify-end gap-2">Total Amount : {parseFloat(formData?.total_amount ||"0").toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                  })}</h2>
                                         {/* <TextField
                                           name="total_amount"
                                            label="Total Amount"
                                           value={formData.total_amount}
                                           onChange={handleChange}
                                           type="amount"
                                            fullWidth
                                         InputLabelProps={{ shrink: true }}
                                         /> */}
                                         
                                     </Grid>

              <Grid item xs={12}  sm={6}>
                <TextField
                  name="memo"
                  label="Memo"
                  fullWidth
                  multiline
                  minRows={2}
                  value={formData.memo}
                  onChange={handleChange}
                />
           
              </Grid>

              {/* ✅ Line Items Table */}
           <Grid item xs={12}>
  <div className="mt-6">
    {/* Header with Add Button */}
    <div className="flex justify-between items-center mb-4">
      <button
        type="button"
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded shadow transition"
        onClick={addLineItem}
      >
        + Add Item
      </button>
    </div>

    {/* Table Container */}
    <div className="border border-gray-300 rounded-lg overflow-hidden shadow-sm">
      {/* Table Header */}
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left bg-gray-50">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              {/* <th className="border px-4 py-3 font-semibold text-gray-700">Task</th> */}
              <th className="border px-4 py-3 font-semibold text-gray-700">Inventory</th>
              {/* <th className="border px-4 py-3 font-semibold text-gray-700">Type</th> */}
              <th className="border px-4 py-3 font-semibold text-gray-700">Unit Price ($)</th>
              <th className="border px-4 py-3 font-semibold text-gray-700">Quantity</th>
              <th className="border px-4 py-3 font-semibold text-gray-700">PO Unit Price ($)</th>
              <th className="border px-4 py-3 font-semibold text-center text-gray-700">
                Actions
              </th>
            </tr>
          </thead>


      {/* Scrollable Body */}
  
          <tbody  className="min-w-full text-sm text-left bg-white">
            {lineItems?.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50 transition">
                {/* Task Select */}
                {/* <td className="border px-3 py-2"> */}
                  {/* <select
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.task_id}
                    required
                    onChange={(e) =>
                      handleLineItemChange(index, "task_id", e.target.value)
                    }
                  >
                    <option value="">Select Task</option>
                    {taskList.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.task_code} - {t.task_name}
                      </option>
                    ))}
                  </select>
                </td> */}

                {/* Inventory Select */}
                <td className="border px-3 py-2">
                  <select
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.inventory_id}
                    required
                    onChange={(e) =>
                      handleLineItemChange(index, "inventory_id", e.target.value)
                    }
                  >
                    <option value="">Select Inventory</option>
                    {invetoryArray.map((inv) => (
                      <option key={inv.id} value={inv.id}>
                        {inv.inventory_name}
                      </option>
                    ))}
                  </select>
                </td>

                {/* Expense Type */}
                {/* <td className="border px-3 py-2">
                  <select
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.expense_type}
                    required
                    onChange={(e) =>
                      handleLineItemChange(index, "expense_type", e.target.value)
                    }
                  >
                    <option value="">Select Type</option>
                    {expenseTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </td> */}

                {/* Unit Price */}
                <td className="border px-3 py-2">
                  <input
                    type="number"
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.unit_price}
                    onChange={(e) =>
                      handleLineItemChange(index, "unit_price", e.target.value)
                    }
                  />
                </td>

                {/* Quantity */}
                <td className="border px-3 py-2">
                  <input
                    type="number"
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item.quantity}
                    onChange={(e) =>
                      handleLineItemChange(index, "quantity", e.target.value)
                    }
                  />
                </td>
  {/* Quantity */}
                <td className="border px-3 py-2">
                  <input
                    type="number"
                    className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={item?.po_unit_price}
                    onChange={(e) =>
                      handleLineItemChange(index, "po_unit_price", e.target.value)
                    }
                  />
                </td>
                {/* Remove Button */}
                <td className="border px-3 py-2 text-center">
                  <IconButton
                    onClick={() => removeLineItem(index)}
                    className="text-red-600 hover:text-red-800 transition"
                    title="Remove item"
                  >
                    <Delete />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
     
        </table>
      </div>
    </div>
  </div>
</Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="button" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              {editMode ? "Update" : "Save"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      
    </>
  );
}

export const convertDateIsoDate = (params) => {
  let date;

  if (params?.value) {
    date = new Date(params.value);
  } else {
    date = new Date(params);
  }

  if (isNaN(date.getTime())) {
    return "N/A";
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const monthString = month < 10 ? `0${month}` : `${month}`;
  const dayString = day < 10 ? `0${day}` : `${day}`;

  return `${monthString}/${dayString}/${year}`;
};


function BillsFiltersUI({
  BillNO,
  Status,
  Pono,
  fromDate,
  toDate,
  setBillNO,
  setStatus,
  setPono,
  setFromDate,
  setToDate,
  reset,
}) {
  return (
    <Box className="pmt-title-box space-y-4">
      <Box className="typography-title">
        <Typography
          variant="h1"
          className="pmt-headings-h1 text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100"
        >
          Bills
        </Typography>
      </Box>

      {/* Filter Card */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 sm:gap-4 rounded-[10px] p-4 sm:p-6 mb-2
                   bg-white/80 dark:bg-gray-900/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 border border-gray-200 dark:border-gray-700 shadow-sm"
      >
        {/* Bill No */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="bill-no-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by Bill No.
          </label>
          <input
            id="bill-no-input"
            type="text"
            value={BillNO || ""}
            onChange={(e) => setBillNO(e.target.value)}
            placeholder="Enter the Invoice Payment No."
            className="w-full h-10 sm:h-11 text-[#000] rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* Status */}
        {/* <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="status-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by Status
          </label>
          <input
            id="status-input"
            type="text"
            value={Status || ""}
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Enter the Status"
          className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
      />
        </div> */}

        {/* PO Number */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="po-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by PO Number
          </label>
          <input
            id="po-input"
            type="text"
            value={Pono || ""}
            onChange={(e) => setPono(e.target.value)}
            placeholder="Enter the PO Number"
            className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* Start Date */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="from-date-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by Start Date
          </label>
          <input
            id="from-date-input"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* End Date */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
          <label
            htmlFor="to-date-input"
            className="capitalize text-gray-800 dark:text-gray-100 font-medium text-xs sm:text-sm"
          >
            Filter by End Date
          </label>
          <input
            id="to-date-input"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            min={fromDate}
            className="w-full h-10 sm:h-11 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 text-sm text-gray-900 dark:text-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-blue-500 transition-colors duration-200"
          />
        </div>

        {/* Reset Button */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 flex justify-start items-end">
          {BillNO || Status || Pono || fromDate || toDate ? (
            <button
              onClick={() => reset()}
              className="group inline-flex items-center gap-1 mb-1 rounded-[5px] px-[12px] py-[6px] text-xs sm:text-sm font-medium text-white bg-gray-900 hover:bg-gray-800 active:scale-95 transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-gray-900"
            >
              {/* Icon (refresh) */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-[15px] h-[15px] group-hover:rotate-[-20deg] transition-transform duration-150"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
              RESET
            </button>
          ) : null}
        </div>

        {/* Optional: Create Bill (kept commented as in original) */}
        {/**
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1  flex-justify-center items-center">
          <label className="capitalize text-[#000] mb-2 font-medium"></label>
          <button
            type="button"
            onClick={() => router.push(`/bills/create-bill`)}
            className="bg-[#00308F] gap-2 h-[45px] text-[#fff] font-semibold capitalize p-[5px] text-md text-sm rounded-[5px] px-[20px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff] float-right"
          >
            Create Bill
          </button>
        </div> 
        */}
      </div>
    </Box>
  );
}
